import gsap from './vendors/gsap'
import './components/accordion'
import './components/header'
import './components/discoverTabs'
import './components/popover'
import './components/arcSystem'
import './components/map'
import hero from './components/hero'
import { reveal } from './utils/animation';

$(() => {
	gsap.init();
	hero.init();

	$('.js-reveal').each((_, element) => {
		reveal(element);
	});
});

window.addEventListener('load', () => {
	window.ScrollTrigger.refresh();
});
